const Loader = () => {
  return (
    <div className="w-full flex justify-center">
      {/* @ts-ignore */}
      <lottie-player
        src="/loader.json"
        background="#FFFFFF"
        speed="1"
        style={{ width: " 150px", height: "150px" }}
        loop
        autoplay
        direction="1"
        mode="normal"
      />
    </div>
  );
};
export default Loader;
